/*
 *
 * FloatingDownloadTile
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 18-Jun-2025
*/

import FloatingDownloadTile from './FloatingDownloadTileContainer'

export default FloatingDownloadTile
